/**
 * PAYAPAYA Official Website Internationalization (i18n) Module
 * Supports: Korean (ko), Japanese (ja), English (en)
 * Auto-detects browser locale, persists choice in localStorage, dynamic UI switching
 */

const I18N_DICT = {
    ko: {
        brand_title: '파야파야',
        logo_img: 'assets/title_text_ko.png',
        tutorial_banner_img: 'assets/tutorial_banner_ko.png',
        nav_rankings: '랭킹 & 대전 로그',
        nav_rank_short: '랭킹',
        nav_home: '홈',
        nav_howtoplay: '게임 룰 & 조작법',
        btn_google_play: '구글 플레이',
        btn_app_store: '앱스토어',
        hero_tagline: '손에 땀을 쥐는 1v1 액션<br class="mobile-break"> 실시간 퍼즐 배틀!',
        hero_desc: '같은 색 블록 4개를 모아 팡! 짜릿한 연쇄 콤보로 상대방을 날려버리세요!',
        feat_match4_title: '4개만 모이면 팡팡!',
        feat_match4_desc: '룰은 아주 간단해요! 같은 색 파야 4개를 붙이면 말랑말랑 기분 좋게 팡 터집니다.',
        feat_vs_title: '실시간 1v1 진검승부',
        feat_vs_desc: '전 세계 유저들과 펼치는 실시간 두뇌 배틀! 연속 콤보를 터뜨려 상대방에게 방해 블록 폭탄을 쏟아부으세요.',
        feat_tiers_title: '13단계 티어 레이스',
        feat_tiers_desc: '1,000점부터 시작하는 치열한 레이팅! 초보부터 절대신까지 정상의 자리에 도전하세요.',
        item_section_title: '전세를 뒤집는 배틀 아이템',
        item_section_sub: '위기의 순간, 역전의 한 방을 노리세요!',
        item_cloud_title: '먹구름 공격 (Cloud)',
        item_cloud_desc: '상대방 필드를 뽀얀 먹구름으로 뒤덮어 시야를 가리고 연쇄 흐름을 방해합니다!',
        item_bubble_title: '버블 쉴드 (Bubble)',
        item_bubble_desc: '영롱한 비눗방울 방패로 내 필드를 감싸 쏟아지는 방해 블록을 든든하게 막아냅니다.',
        item_magnet_title: '자석 파워 (Magnet)',
        item_magnet_desc: '강력한 자력으로 떨어지는 파야를 빈틈으로 쏙 빨아들여 고속 정렬과 드롭을 돕습니다.',
        tier_section_title: '공식 랭킹 티어',
        btn_view_ladder: '실시간 랭킹 보러가기 ➔',
        rule_section_title: '게임 룰 & 조작 가이드',
        academy_title: '🎓 튜토리얼 & 기본 조작법',
        academy_desc: '기본 조작부터 실전 연쇄 콤보까지! 모바일 터치 제스처와 아케이드 가상 패드 중 손에 맞는 조작 방식을 익혀보세요.',
        control_subheading: '🕹️ 두 가지 조작 방식 (취향대로 선택!)',
        ctrl_touch_title: '터치 & 제스처 모드',
        ctrl_touch_badge: '모바일 기본',
        ctrl_touch_move: '좌우 슬라이드',
        ctrl_touch_move_desc: '화면을 좌우로 가볍게 밀어 떨어지는 파야의 위치를 이동합니다.',
        ctrl_touch_rot: '좌우 탭 회전',
        ctrl_touch_rot_desc: '화면 왼쪽을 누르면 반시계 방향, 오른쪽을 누르면 시계 방향으로 회전합니다.',
        ctrl_touch_drop: '아래 슬라이드 / 위로 튕기기',
        ctrl_touch_drop_desc: '아래로 내리면 빠른 낙하(소프트 드롭), 위로 튕기면 즉시 바닥으로 내리는 하드 드롭!',
        ctrl_pad_title: '가상 게임패드 모드',
        ctrl_pad_badge: '아케이드 손맛',
        ctrl_pad_dpad: '4방향 십자키',
        ctrl_pad_dpad_desc: '화면 좌측 십자키로 한 칸씩 칼각 이동과 스피드 다운을 정밀하게 제어합니다.',
        ctrl_pad_btn: 'A/B 회전 버튼',
        ctrl_pad_btn_desc: '화면 우측 회전 버튼으로 딜레이 없이 즉각 반응하는 아케이드 손맛을 느껴보세요.',
        ctrl_pad_switch: '언제든 모드 변경',
        ctrl_pad_switch_desc: '게임 설정(⚙️) 메뉴에서 터치 제스처와 가상 게임패드를 언제든지 변경할 수 있습니다.',
        rules_subheading: '🧩 4가지 핵심 배틀 룰 & 승리 비결',
        rule_step1_title: '4개 모아 터뜨리기',
        rule_step1_desc: '가로나 세로로 같은 색 파야 4개 이상이 닿으면 팡! 터지며 점수를 얻습니다.',
        rule_step2_title: '짜릿한 연쇄 콤보',
        rule_step2_desc: '블록이 터진 후 위에서 떨어진 블록들이 다시 이어 터지면 강력한 연쇄(Chain)가 발동합니다!',
        rule_step3_title: '방해 블록 폭탄 투하',
        rule_step3_desc: '연쇄가 커질수록 상대방 필드에 무시무시한 방해 블록(오자마) 폭탄이 쏟아집니다.',
        rule_step4_title: '3번째 열(X 표시) 막히면 KO!',
        rule_step4_desc: '가운데 3번째 열(X 표시)까지 블록이 꽉 차서 새 블록이 나올 수 없으면 즉시 패배합니다.',
        cta_download_title: '지금 바로 실시간<br class="mobile-break"> 퍼즐 배틀에 도전하세요!',
        cta_download_desc: '구글 플레이와 앱스토어에서 무료 다운로드! 빠른 매칭, 쫀득한 손맛, 짜릿한 1v1 랭킹 배틀을 즐겨보세요.',
        footer_rights: '© PAYAPAYA - 실시간 1v1 액션 퍼즐 배틀. All rights reserved.',
        privacy_policy: '개인정보처리방침',
        
        // Ranking Page
        ranking_page_title: '🏆 아레나 리더보드<br class="mobile-break"> & 대전 로그',
        ranking_page_desc: '실시간 랭킹 순위와<br class="mobile-break"> 박진감 넘치는 1v1 대전 기록을 확인하세요!',
        tab_leaderboard: '🏆 글로벌 리더보드',
        tab_battle_logs: '⚔️ 실시간 대전 기록',
        auto_sync_active: '실시간 자동 동기화 활성',
        th_rank: '순위',
        th_player: '플레이어',
        th_tier: '티어',
        th_rating: '레이팅',
        th_record: '전적',
        th_win_rate: '승률',
        th_max_chain: '연쇄',
        top50_title: 'TOP 50 랭킹 플레이어',
        recent_battles_title: '실시간 1v1 아레나 대전 로그',
        recent_battles_desc: '전 세계 플레이어들의 최근 경기 결과와 승패 기록',
        room_no: '룸',
        match_duration: '경기 시간',
        chains: '연쇄',
        garbage: '방해 블록',
        win: '승',
        lose: '패',
        draw: '무',
        streak: '연승',
        champion: '1위 챔피언',
        second_place: '2위',
        third_place: '3위',
        
        // Replay Modal
        replay_title: '배틀 리플레이',
        replay_match_prefix: '매치',
        replay_btn_play: '▶ 재생',
        replay_btn_pause: '⏸ 일시정지',
        replay_btn_loading: '⏳ 로딩...',
        replay_btn_prev5: '⏪ -5초',
        replay_btn_next5: '⏩ +5초',
        replay_btn_sound_on: '🔊 효과음',
        replay_btn_sound_off: '🔇 음소거',
        replay_btn_share: '🔗 링크 공유',
        replay_share_copied: '리플레이 공유 링크가 클립보드에 복사되었습니다!',
        replay_close_title: '닫기 (ESC)',
        replay_err_load: '리플레이 데이터를 불러오지 못했습니다.',
        replay_badge_btn: '🎬 리플레이',
        replay: '리플레이',
        replay_unmute_hint: '탭하여 소리 켜기',
        no_ranking_data: '랭킹 기록이 없습니다.',
        no_battle_logs: '로그가 없습니다.',
        search_placeholder: '닉네임 또는 유저 코드로 검색...',
        search_btn: '검색',
        reset_filter: '전체 보기',
        filter_user_title: "'{nick}' 님의 배틀 전적 & 리플레이",
        filter_search_title: "'{keyword}' 검색 결과",
        total_matches: '총 {total}경기',
        page_prev: '◀ 이전',
        page_next: '다음 ▶',
        user_profile_share: '전적 공유 링크 복사',
        user_link_copied: '유저 전적 링크가 클립보드에 복사되었습니다!',
        stat_views: '조회수',
        stat_likes: '좋아요',
        already_liked: '이미 좋아요를 누르셨습니다 (IP당 1회)',
        like_success: '❤️ 좋아요를 눌렀습니다!',
        tier_names: ['초보', '하수', '중수', '고수', '영웅', '지존', '초인', '패왕', '제왕', '초급신', '중급신', '상급신', '절대신']
    },
    ja: {
        brand_title: 'ぱやぱや',
        logo_img: 'assets/title_text_ja.png',
        tutorial_banner_img: 'assets/tutorial_banner_ja.png',
        nav_rankings: 'ランキング & 対戦ログ',
        nav_rank_short: 'ランキング',
        nav_home: 'ホーム',
        nav_howtoplay: 'あそびかた & ルール',
        btn_google_play: 'Google Play',
        btn_app_store: 'App Store',
        hero_tagline: '白熱のリアルタイム 1v1<br class="mobile-break"> アクションパズルバトル！',
        hero_desc: '同じ色を4つくっつけてポン！ド派手な大連鎖でライバルをぶっ飛ばそう！',
        feat_match4_title: '4つくっつけてポポポン！',
        feat_match4_desc: 'ルールはとっても簡単！同じ色のパヤを4つくっつけると、ぷるぷる弾けて気持ちよく消えちゃいます。',
        feat_vs_title: '熱狂のリアルタイム 1v1',
        feat_vs_desc: '世界中のプレイヤーと白熱の真剣勝負！大連鎖を決めて相手の盤面におじゃまブロックを大量投下！',
        feat_tiers_title: '全13段階のランクマッチ',
        feat_tiers_desc: '初期レート1,000ptからスタート！見習いから絶対神まで、頂点を目指して階級を駆け上がろう。',
        item_section_title: '勝負を覆すバトルアイテム',
        item_section_sub: 'ピンチをチャンスに変える逆転の一撃！',
        item_cloud_title: 'もくもく雲 (Cloud)',
        item_cloud_desc: '相手の画面を真っ白な雲で包み込み、視界を奪って連鎖の組み立てをジャマしちゃいます！',
        item_bubble_title: 'バブルシールド (Bubble)',
        item_bubble_desc: 'キラキラ光る泡バリアで盤面をガード！頭上から降ってくるおじゃまブロックをシャットアウト。',
        item_magnet_title: 'パワーマグネット (Magnet)',
        item_magnet_desc: '強力な磁力で落ちてくるパヤを隙間にピタッと吸い寄せ、超高速ドロップをアシスト！',
        tier_section_title: '公式対戦クラス階級',
        btn_view_ladder: 'リアルタイム順位を見る ➔',
        rule_section_title: 'あそびかた & ルール',
        academy_title: '🎓 チュートリアル＆基本操作',
        academy_desc: '初心者から上級者まで！スマホ向け直感タッチ操作と、レトロゲーム感覚の十字キーパッドから自分に合ったスタイルを選べます。',
        control_subheading: '🕹️ 選べる2つの操作スタイル',
        ctrl_touch_title: 'タッチ＆スワイプ操作',
        ctrl_touch_badge: 'スマホ推奨',
        ctrl_touch_move: '左右スライド',
        ctrl_touch_move_desc: '画面を左右に指でスッとなぞって、落ちてくるパヤの位置をスムーズに移動。',
        ctrl_touch_rot: '画面左右タップ',
        ctrl_touch_rot_desc: '左側タップで反時計回り、右側タップで時計回りに素早く回転します。',
        ctrl_touch_drop: '下スライド / 上フリック',
        ctrl_touch_drop_desc: '下へスライドで高速落下（ソフトドロップ）、上へフリックで一瞬で着地（ハードドロップ）！',
        ctrl_pad_title: 'バーチャルゲームパッド',
        ctrl_pad_badge: 'アーケード仕様',
        ctrl_pad_dpad: '4方向十字キー',
        ctrl_pad_dpad_desc: '画面左の十字キーで、マス目通りの精密な横移動とスムーズな高速下操作が可能。',
        ctrl_pad_btn: '回転ボタン',
        ctrl_pad_btn_desc: '画面右の回転ボタンで、遅延ゼロのクイックな回転フィーリングを体感！',
        ctrl_pad_switch: 'いつでも変更可能',
        ctrl_pad_switch_desc: 'ゲーム内の設定(⚙️)から、タッチ操作とゲームパッドをいつでも自由に切り替えられます。',
        rules_subheading: '🧩 4つの基本バトルルール＆勝利の秘訣',
        rule_step1_title: '4つ繋げて消去',
        rule_step1_desc: 'タテ・ヨコに同じ色のパヤを4つ以上くっつけると、ポンと弾けて得点を獲得！',
        rule_step2_title: '爽快な連鎖コンボ',
        rule_step2_desc: '消えた後に落ちてきたパヤが続けて揃うと、大連鎖(Chain)が発動！',
        rule_step3_title: 'おじゃまブロック攻撃',
        rule_step3_desc: '連鎖が伸びるほど、相手のフィールドに大量のおじゃまブロックの雨を降らせます！',
        rule_step4_title: '中央(3列目)の❌が詰まったらKO！',
        rule_step4_desc: '中央の3列目（❌マーク）までブロックが積み上がり、次のブロックが出せなくなると即敗北！',
        cta_download_title: '今すぐ白熱の<br class="mobile-break"> パズルバトルに参戦！',
        cta_download_desc: 'Google Play & App Storeにて無料配信中！サクサク快適なオンラインマッチングと、本格アリーナ対戦を楽しもう。',
        footer_rights: '© PAYAPAYA - リアルタイム 1v1 アクションパズルバトル. All rights reserved.',
        privacy_policy: 'プライバシーポリシー',
        
        // Ranking Page
        ranking_page_title: '🏆 アリーナリーダーボード<br class="mobile-break"> & 対戦ログ',
        ranking_page_desc: 'リアルタイムランキングと<br class="mobile-break"> 白熱の1v1対戦履歴をチェック！',
        tab_leaderboard: '🏆 グローバルランキング',
        tab_battle_logs: '⚔️ リアルタイム対戦ログ',
        auto_sync_active: 'リアルタイム自動更新中',
        th_rank: '順位',
        th_player: 'プレイヤー',
        th_tier: '階級',
        th_rating: 'レート',
        th_record: '戦績',
        th_win_rate: '勝率',
        th_max_chain: '連鎖',
        top50_title: 'TOP 50 ランキングプレイヤー',
        recent_battles_title: '最新 1v1 アリーナ対戦ログ',
        recent_battles_desc: '世界中のプレイヤーたちの直近マッチ結果と勝敗スコア',
        room_no: 'ルーム',
        match_duration: '試合時間',
        chains: '連鎖',
        garbage: 'おじゃま',
        win: '勝',
        lose: '敗',
        draw: '分',
        streak: '連勝',
        champion: '1位 チャンピオン',
        second_place: '2位',
        third_place: '3位',

        // Replay Modal
        replay_title: 'バトルリプレイ',
        replay_match_prefix: 'マッチ',
        replay_btn_play: '▶ 再生',
        replay_btn_pause: '⏸ 一時停止',
        replay_btn_loading: '⏳ 読み込み中...',
        replay_btn_prev5: '⏪ -5秒',
        replay_btn_next5: '⏩ +5秒',
        replay_btn_sound_on: '🔊 効果音',
        replay_btn_sound_off: '🔇 ミュート',
        replay_btn_share: '🔗 リンク共有',
        replay_share_copied: 'リプレイ共有リンクがクリップボードにコピーされました！',
        replay_close_title: '閉じる (ESC)',
        replay_err_load: 'リプレイデータを読み込めませんでした。',
        replay_badge_btn: '🎬 リプレイ',
        replay: 'リプレイ',
        replay_unmute_hint: 'タップして音声を再生',
        no_ranking_data: 'ランキング記録がありません。',
        no_battle_logs: 'ログがありません。',
        search_placeholder: 'ニックネームまたはユーザーコードで検索...',
        search_btn: '検索',
        reset_filter: 'すべて表示',
        filter_user_title: "「{nick}」の対戦履歴＆リプレイ",
        filter_search_title: "「{keyword}」の検索結果",
        total_matches: '全{total}試合',
        page_prev: '◀ 前へ',
        page_next: '次へ ▶',
        user_profile_share: '戦績リンクをコピー',
        user_link_copied: 'ユーザー戦績リンクがクリップボードにコピーされました！',
        stat_views: '閲覧数',
        stat_likes: 'いいね',
        already_liked: 'すでに「いいね」済みです (IPごと1回)',
        like_success: '❤️ 「いいね」しました！',
        tier_names: ['見習い', '初級', '中級', '上級', '達人', '英雄', '至尊', '超人', '覇王', '初級神', '中級神', '上級神', '絶対神']
    },
    en: {
        brand_title: 'PAYAPAYA',
        logo_img: 'assets/title_text_en.png',
        tutorial_banner_img: 'assets/tutorial_banner_en.png',
        nav_rankings: 'Leaderboard & Battles',
        nav_rank_short: 'RANK',
        nav_home: 'Home',
        nav_howtoplay: 'HOW TO PLAY',
        btn_google_play: 'GOOGLE PLAY',
        btn_app_store: 'APP STORE',
        hero_tagline: 'HIGH-OCTANE 1v1 ACTION<br class="mobile-break"> REALTIME PUZZLE BATTLE!',
        hero_desc: 'Drop blocks, match 4 to pop, and blast your rivals with mega chain combos!',
        feat_match4_title: 'Match 4 & Pop!',
        feat_match4_desc: 'Simple, satisfying, and wildly addictive! Group four blobs of the same color to pop them in juicy arcade style.',
        feat_vs_title: 'Realtime 1v1 Showdowns',
        feat_vs_desc: 'Go head-to-head against players worldwide! Pull off massive chain cascades to bury your opponent under nuisance blocks.',
        feat_tiers_title: '13 Competitive Tiers',
        feat_tiers_desc: 'Climb the global ELO ladder! Start at 1,000 points and battle your way from Rookie all the way up to Absolute God.',
        item_section_title: 'Game-Changing Items',
        item_section_sub: 'Turn the tide when you\'re on the ropes!',
        item_cloud_title: 'Cloud Blinder',
        item_cloud_desc: 'Summon puffy storm clouds over your opponent\'s board to blind their vision and sabotage their combos!',
        item_bubble_title: 'Bubble Shield',
        item_bubble_desc: 'Wrap your board in a sparkling bubble shield to deflect incoming waves of nuisance garbage.',
        item_magnet_title: 'Power Magnet',
        item_magnet_desc: 'Harness magnetic pull to snap falling pieces cleanly into place for lightning-fast drops and clutch clears.',
        tier_section_title: 'Competitive Class Tiers',
        btn_view_ladder: 'View Live Ladder ➔',
        rule_section_title: 'How to Play & Controls',
        academy_title: '🎓 In-Game Academy & Controls',
        academy_desc: 'From basic moves to tournament-level cascades! Choose between fluid mobile touch gestures and tactile virtual D-pad controls.',
        control_subheading: '🕹️ Dual Control Schemes (Pick Your Style)',
        ctrl_touch_title: 'Swipe & Tap Gestures',
        ctrl_touch_badge: 'Mobile Friendly',
        ctrl_touch_move: 'Slide Left / Right',
        ctrl_touch_move_desc: 'Smoothly glide your finger across the screen to steer falling Payas.',
        ctrl_touch_rot: 'Tap Left / Right',
        ctrl_touch_rot_desc: 'Tap the left half of the screen to spin Counter-Clockwise (CCW), or the right half for Clockwise (CW).',
        ctrl_touch_drop: 'Slide Down / Flick Up',
        ctrl_touch_drop_desc: 'Swipe down for soft drop, or flick up for an instantaneous hard drop straight to the floor.',
        ctrl_pad_title: 'Virtual Gamepad Mode',
        ctrl_pad_badge: 'Arcade Feel',
        ctrl_pad_dpad: '4-Way Cross D-Pad',
        ctrl_pad_dpad_desc: 'Tactile on-screen directional pad on the left for precision, grid-locked placement.',
        ctrl_pad_btn: 'Dual Action Buttons',
        ctrl_pad_btn_desc: 'Responsive spin buttons on the right thumb area for zero-delay rotation reactions.',
        ctrl_pad_switch: 'Instant Switch',
        ctrl_pad_switch_desc: 'Easily toggle between Touch gestures and Gamepad mode in the in-game Settings (⚙️) anytime.',
        rules_subheading: '🧩 4 Core Rules & Victory Conditions',
        rule_step1_title: 'Connect 4 to Pop',
        rule_step1_desc: 'Cluster 4 or more adjacent blobs of the same color horizontally or vertically to clear them instantly.',
        rule_step2_title: 'Cascading Combos',
        rule_step2_desc: 'When blobs pop, the pieces above drop down. Align falling drops to trigger epic chain reactions!',
        rule_step3_title: 'Nuisance Garbage Attack',
        rule_step3_desc: 'The higher your combo chain, the more crushing nuisance garbage drops onto your rival\'s board.',
        rule_step4_title: 'Column 3 Danger KO!',
        rule_step4_desc: 'Watch column 3! If blocks pile up and block the ❌ spawn point, that player suffers an instant knockout.',
        cta_download_title: 'JUMP INTO THE 1v1<br class="mobile-break"> PUZZLE ARENA!',
        cta_download_desc: 'Available for free on Google Play & the Apple App Store! Enjoy snappy matchmaking, authentic arcade action, and global ELO ladder rankings.',
        footer_rights: '© PAYAPAYA - Realtime 1v1 Action Puzzle Battle. All rights reserved.',
        privacy_policy: 'Privacy Policy',
        
        // Ranking Page
        ranking_page_title: '🏆 ARENA LEADERBOARD<br class="mobile-break"> & BATTLE LOGS',
        ranking_page_desc: 'Check out live player rankings<br class="mobile-break"> and exciting 1v1 match results!',
        tab_leaderboard: '🏆 Global Leaderboard',
        tab_battle_logs: '⚔️ Live Battle Logs',
        auto_sync_active: 'Live Auto-Sync Active',
        th_rank: 'RANK',
        th_player: 'PLAYER',
        th_tier: 'TIER',
        th_rating: 'RATING',
        th_record: 'RECORD',
        th_win_rate: 'WIN RATE',
        th_max_chain: 'CHAINS',
        top50_title: 'Top 50 Ranked Players',
        recent_battles_title: 'Recent 1v1 Arena Matches',
        recent_battles_desc: 'Realtime match results from global puzzle combatants',
        room_no: 'Room',
        match_duration: 'Duration',
        chains: 'Chains',
        garbage: 'Garbage',
        win: 'W',
        lose: 'L',
        draw: 'D',
        streak: 'Streak',
        champion: '1ST CHAMPION',
        second_place: '2ND PLACE',
        third_place: '3RD PLACE',

        // Replay Modal
        replay_title: 'BATTLE REPLAY',
        replay_match_prefix: 'Match',
        replay_btn_play: '▶ Play',
        replay_btn_pause: '⏸ Pause',
        replay_btn_loading: '⏳ Loading...',
        replay_btn_prev5: '⏪ -5s',
        replay_btn_next5: '⏩ +5s',
        replay_btn_sound_on: '🔊 Sound',
        replay_btn_sound_off: '🔇 Mute',
        replay_btn_share: '🔗 Share Link',
        replay_share_copied: 'Replay share link copied to clipboard!',
        replay_close_title: 'Close (ESC)',
        replay_err_load: 'Failed to load replay data.',
        replay_badge_btn: '🎬 Replay',
        replay: 'Replay',
        replay_unmute_hint: 'Tap to unmute',
        no_ranking_data: 'No ranking records found.',
        no_battle_logs: 'No match logs found.',
        search_placeholder: 'Search by nickname or user code...',
        search_btn: 'Search',
        reset_filter: 'Show All',
        filter_user_title: "Match Logs & Replays for '{nick}'",
        filter_search_title: "Search results for '{keyword}'",
        total_matches: 'Total {total} matches',
        page_prev: '◀ Prev',
        page_next: 'Next ▶',
        user_profile_share: 'Copy Profile Link',
        user_link_copied: 'User profile link copied to clipboard!',
        stat_views: 'Views',
        stat_likes: 'Likes',
        already_liked: 'You have already liked this match (1 like per IP)',
        like_success: '❤️ Liked this match!',
        tier_names: ['Beginner', 'Apprentice', 'Novice', 'Expert', 'Hero', 'Master', 'Super', 'Conqueror', 'Overlord', 'Demi-God', 'High God', 'Elder God', 'Absolute God']
    }
};

class PayaI18n {
    constructor() {
        this.currentLang = this.detectLanguage();
    }

    detectLanguage() {
        // 1. Saved preference in localStorage
        const saved = localStorage.getItem('payapaya_lang');
        if (saved && ['ko', 'ja', 'en'].includes(saved)) {
            return saved;
        }

        // 2. Browser language detection
        const navLangs = navigator.languages || [navigator.language || navigator.userLanguage || 'en'];
        for (const l of navLangs) {
            const lower = l.toLowerCase();
            if (lower.startsWith('ko')) return 'ko';
            if (lower.startsWith('ja')) return 'ja';
            if (lower.startsWith('en')) return 'en';
        }

        return 'en';
    }

    t(key) {
        const dict = I18N_DICT[this.currentLang] || I18N_DICT.en;
        return dict[key] !== undefined ? dict[key] : (I18N_DICT.en[key] !== undefined ? I18N_DICT.en[key] : key);
    }

    setLanguage(lang) {
        if (!['ko', 'ja', 'en'].includes(lang)) lang = 'en';
        this.currentLang = lang;
        localStorage.setItem('payapaya_lang', lang);
        document.documentElement.lang = lang;
        this.applyToDOM();

        // Sync any language selector dropdowns
        document.querySelectorAll('.paya-lang-select').forEach(select => {
            select.value = lang;
        });

        // Sync mobile flag badges
        this.updateFlagBadges(lang);

        // Trigger custom listener if page needs re-rendering
        if (typeof window.onPayaLanguageChanged === 'function') {
            window.onPayaLanguageChanged(lang);
        }
    }

    updateFlagBadges(lang) {
        const flagMap = { ko: '🇰🇷', en: '🇺🇸', ja: '🇯🇵' };
        document.querySelectorAll('.lang-flag-badge').forEach(badge => {
            badge.textContent = flagMap[lang] || '🌐';
        });
    }

    applyToDOM() {
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.getAttribute('data-i18n');
            const val = this.t(key);
            if (val) el.textContent = val;
        });

        document.querySelectorAll('[data-i18n-html]').forEach(el => {
            const key = el.getAttribute('data-i18n-html');
            const val = this.t(key);
            if (val) el.innerHTML = val;
        });

        document.querySelectorAll('[data-i18n-title]').forEach(el => {
            const key = el.getAttribute('data-i18n-title');
            const val = this.t(key);
            if (val) el.setAttribute('title', val);
        });

        document.querySelectorAll('[data-i18n-src]').forEach(el => {
            const key = el.getAttribute('data-i18n-src');
            const val = this.t(key);
            if (val) el.setAttribute('src', val);
        });

        // Optional title tag update if data-i18n-page-title exists
        const pageTitleEl = document.querySelector('title[data-i18n]');
        if (pageTitleEl) {
            pageTitleEl.textContent = this.t(pageTitleEl.getAttribute('data-i18n'));
        }

        // Automatic in-game tier name replacement
        const tierNames = this.t('tier_names');
        if (Array.isArray(tierNames)) {
            document.querySelectorAll('[data-tier-idx]').forEach(el => {
                const idx = parseInt(el.getAttribute('data-tier-idx'), 10);
                if (!isNaN(idx) && tierNames[idx]) {
                    el.textContent = tierNames[idx];
                }
            });
        }
    }

    init() {
        document.documentElement.lang = this.currentLang;
        this.applyToDOM();
        this.updateFlagBadges(this.currentLang);

        // Bind existing selectors
        document.querySelectorAll('.paya-lang-select').forEach(select => {
            select.value = this.currentLang;
            select.addEventListener('change', (e) => {
                this.setLanguage(e.target.value);
            });
        });
    }
}

// Global instance
window.payaI18n = new PayaI18n();

document.addEventListener('DOMContentLoaded', () => {
    window.payaI18n.init();
});
